import { FRAXLEND_PAIR_ABI } from '@/config/abis/FraxlendPair.abi'
import { toBigInt } from '@/utils/bigNumber'
import { ActionConfig, ActionContext } from '../../../logic/types'
import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { IsolatedLendDepositAction } from '../types'
import { getPortfolioBalanceInvalidationKeys } from '@/features/actions/logic/invalidation'

export function createIsolatedLendDepositActionConfig(
  action: IsolatedLendDepositAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      const depositAmount = toBigInt(action.token.toBaseUnit(action.value))

      return ensureConfigTypes({
        abi: FRAXLEND_PAIR_ABI,
        address: action.pairAddress,
        functionName: 'deposit',
        chainId,
        args: [depositAmount, account],
      })
    },

    invalidates: () => getPortfolioBalanceInvalidationKeys({ account, chainId }),
  }
}
